module.exports = __webpack_public_path__ + "static/sakuratokyo-logo-9b9ba62dfdadbd61f3dda1b7f325e40d.png";